/* eslint-disable */
import Cookies from 'js-cookie';
import React, { lazy } from 'react';
import { ReactComponent as CellIcon } from '../assets/svgIcons/sidebarNav/Cell-Icon.svg';
import { ReactComponent as ImportData } from '../assets/svgIcons/sidebarNav/ImportData.svg';
import { ReactComponent as VectorGlovalGiving } from '../assets/svgIcons/sidebarNav/VectorGlovalGiving.svg';
import { ReactComponent as GoalIcon } from '../assets/images/Goal.svg';
import { ReactComponent as FormTemplatesIcon } from '../assets/images/Forms-Template.svg';
import { ReactComponent as FormsIcon } from '../assets/images/Forms.svg';
import { ReactComponent as AnnouncementIcon } from '../assets/images/Announcement.svg';
import { ReactComponent as LearningIcon } from '../assets/images/Learning.svg';
import { ReactComponent as TrainingIcon } from '../assets/images/Training.svg';
import VectoHealthReportModel from '../screens/Main/Dashboard/VectoHealthReportModel/VectoHealthReportModel';

import HomeIcon from '@material-ui/icons/Home';
import PersonIcon from '@material-ui/icons/Person';
import BusinessIcon from '@material-ui/icons/Business';
import PublicIcon from '@material-ui/icons/Public';
import FinancialAnalysisTab from '../screens/Main/Dashboard/FinancialAnalysisTab';
import SummaryInvoiceByCell from '../screens/Main/Dashboard/SummaryInvoiceByCell/SummaryInvoiceByCell';
import CollectionReport from '../screens/Main/Dashboard/CollectionReport/CollectionReport';
import CollectionReportAll from '../screens/Main/Dashboard/CollectionReportAll/CollectionReportAll';
import SummaryTab from '../screens/Main/Dashboard/SummaryTab/SummaryTab';
import dashboardRoutes from './dashboardRoutesV2';
import { getLoggedInUserData } from '../utils/Helper';

let appNav = [];
const EmployeeDirectory = lazy(() => import('../screens/Main/EmployeeDirectory'));
const ViewEmployeeDetails = lazy(() => import('../screens/Main/ViewEmployeeDetails'));
const ViewFormDetails = lazy(() => import('../screens/Main/ViewFormDetails'));
const AccountDirectoryDetail = lazy(() =>
  import('../screens/Main/AccountDirectory/AccountDirectoryDetail'),
);
const Dashboard = lazy(() => import('../screens/Main/Dashboard'));

const LearningOpportunities = lazy(() => import('../screens/Main/LearningOpportunities'));
const FormTemplate = lazy(() => import('../screens/Main/FormTemplate'));
const Forms = lazy(() => import('../screens/Main/Forms'));
const Announcements = lazy(() => import('../screens/Main/Announcements'));
const GlobalGivingCauses = lazy(() => import('../screens/Main/GlobalGivingCauses'));
const TrainingResources = lazy(() => import('../screens/Main/TrainingResources'));
const AccountDirectory = lazy(() => import('../screens/Main/AccountDirectory'));
const CalendarNotification = lazy(() => import('../screens/Main/CalendarNotification/'));

const QuickBookAccess = lazy(() =>
  import('../screens/Main/Dashboard/QuickBookAccess/QuickBookAccess'),
);

const Goals = lazy(() => import('../screens/Main/Goals'));
const GoalDetails = lazy(() => import('../screens/Main/Goals/GoalDetails'));
const PerformanceSummaryReport = lazy(() =>
  import('../screens/Main/Dashboard/PerformanceSummaryReport'),
);

const Country = lazy(() => import('../screens/Main/CountryList'));
const Cell = lazy(() => import('../screens/Main/CellList'));
const ImportDataTool = lazy(() => import('../screens/Main/ImportDataTool'));
const FormDetail = lazy(() => import('../screens/Main/FormDetail'));
const VectorHealthReport = lazy(() => import('../screens/Main/VectorHealthReport'));
const VectorHealthQuestionReport = lazy(() => import('../screens/Main/VectorHealthQuestionReport'));
const UpdatePassword = lazy(() => import('../screens/Auth/UpdatePassword'));
const UpdateDetails = lazy(() => import('../screens/Main/UpdateDetails'));
const UpdateAccessCode = lazy(() => import('../screens/Auth/UpdateAccessCode'));
const MyCellTab = lazy(() => import('../screens/Main/Dashboard/MyCellTab/MyCellTab'));
const CountryProfitRevenueCharts = lazy(() =>
  import('../screens/Main/Dashboard/CountryProfitRevenueCharts/CountryProfitRevenueCharts'),
);
const userCookie = Cookies.get('user');
const userField = Cookies.get('field');
let userData = [];
if (userCookie) {
  userData = getLoggedInUserData();
} else {
  if (
    window.location.href.indexOf('set-password') < 0 &&
    window.location.href.indexOf('forgot-password') < 0 &&
    window.location.href.indexOf('reset-password') < 0 &&
    window.location.href.indexOf('two-factor-authentication') < 0 &&
    window.location.href.indexOf('create-account') < 0
  ) {
    let noAuthUrls = ['dialogstable']; // add urls here to access without auth
    let urlIndex = noAuthUrls.filter((responses) => window.location.href.indexOf(responses) > -1);

    if (!urlIndex || !urlIndex.length) {
      window.location = '/#/login';
    } else {
      appNav = [];
    }
  }
}

if (userData?.isChangedPassword != 0 || userField == 'accessCode') {
  appNav = [
    {
      name: 'Dashboard',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'dashboard',
      element: <Dashboard />,
      navIconsAlt: <HomeIcon />,
      num: 1,
      children: dashboardRoutes,
    },
    {
      name: 'Performance Summary Report',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'dashboard/performance-review-summary-report/:formTrackerId/:userId/:year',
      element: <PerformanceSummaryReport />,
      navIconsAlt: <HomeIcon />,
    },
    {
      name: 'VectoHealthReportModel',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'qb',
      element: <QuickBookAccess />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'MyPerformanceSalesUser',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'workload',
      element: <SummaryTab />, //MyPerformanceSalesUser CellWorkLoad SummaryTab EmployeeAnalysisTab
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'MyCellTab',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'mycell',
      element: <MyCellTab />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },

    {
      name: 'VectoHealthReportModel',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'qb1',
      element: <CollectionReportAll />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'VectoHealthReportModel',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'qb2',
      element: <FinancialAnalysisTab />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'VectoHealthReportModel',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'qb3',
      element: <SummaryInvoiceByCell />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },

    {
      name: 'VectoHealthReportModel',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'qb5',
      element: <CollectionReport />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'VectoHealthReportModel',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'xyz',
      element: <VectoHealthReportModel />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'CountryProfitRevenueCharts',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'test',
      element: <CountryProfitRevenueCharts />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'View Employee',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'view-employee/:userId/:countryId',
      element: <ViewEmployeeDetails />,
      navIconsAlt: <HomeIcon />,
    },
    {
      name: 'View Form Quetion',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'view-form-questions/:formId/',
      element: <ViewFormDetails />,
      navIconsAlt: <HomeIcon />,
    },
    {
      name: 'Employee Directory',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <PersonIcon />,
      path: 'employee-directory/:formId',
      element: <EmployeeDirectory />,
      navIconsAlt: <PersonIcon />,
      num: 1,
    },
    {
      name: 'CalendarNotification',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <PersonIcon />,
      path: 'calendarnotification',
      element: <CalendarNotification />,
      navIconsAlt: <PersonIcon />,
    },
    {
      name: 'Client Directory',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <BusinessIcon />,
      path: 'client-directory',
      element: <AccountDirectory />,
      navIconsAlt: <BusinessIcon />,
      num: 1,
    },
    {
      name: 'Client Directory Detail',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'view-client-directory/:accountId/:countryId',
      element: <AccountDirectoryDetail />,
      navIconsAlt: <HomeIcon />,
    },
    {
      name: 'Goals',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <GoalIcon />,
      path: 'goals',
      element: <Goals />,
      navIconsAlt: <GoalIcon />,
      num: 1,
    },
    {
      name: 'Goal Details',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <GoalIcon />,
      path: 'goal-details/:id/:type/:year/:goalyear',
      element: <GoalDetails />,
      navIconsAlt: <GoalIcon />,
    },
    {
      name: 'Form Templates',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <FormTemplatesIcon />,
      path: 'form-template/:receivedFormId/:userId',
      element: <FormTemplate />,
      navIconsAlt: <FormTemplatesIcon />,
      num: 1,
    },
    {
      name: 'Forms',
      image: require('../assets/images/Forms.svg').default,
      navIcons: <FormsIcon />,
      path: 'forms/:id',
      element: <Forms />,
      navIconsAlt: <FormsIcon />,
      num: 1,
    },
    {
      name: 'Announcements',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <AnnouncementIcon />,
      path: 'announcements',
      element: <Announcements />,
      navIconsAlt: <AnnouncementIcon />,
      num: 1,
    },
    {
      name: 'Learning Opportunities',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <LearningIcon />,
      path: 'learning-opportunities',
      element: <LearningOpportunities />,
      navIconsAlt: <LearningIcon />,
      num: 1,
    },
    {
      name: 'Global Giving',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <VectorGlovalGiving />,
      path: 'global-giving-causes',
      element: <GlobalGivingCauses />,
      navIconsAlt: <VectorGlovalGiving />,
      num: 1,
    },
    {
      name: 'Training Resources',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <TrainingIcon />,
      path: 'training-resources',
      element: <TrainingResources />,
      navIconsAlt: <TrainingIcon />,
      num: 1,
    },
    {
      name: 'Country',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <PublicIcon />,
      path: 'country-list',
      element: <Country />,
      navIconsAlt: <PublicIcon />,
      num: 1,
    },
    {
      name: 'Cells',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <CellIcon />,
      path: 'cell-list',
      element: <Cell />,
      navIconsAlt: <CellIcon />,
      num: 1,
    },
    {
      name: 'Update Password',
      image: require('../assets/images/dashboard.png').default,
      path: 'update-password',
      element: <UpdatePassword />,
    },
    {
      name: 'Update Details',
      image: require('../assets/images/dashboard.png').default,
      path: 'update-details',
      element: <UpdateDetails />,
    },
    {
      name: 'Update Access Code',
      image: require('../assets/images/dashboard.png').default,
      path: 'update-accesscode',
      element: <UpdateAccessCode />,
    },
    {
      name: 'Form Detail',
      path: 'form-detail',
      element: <FormDetail />,
    },

    {
      name: 'Vector Health Report',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'view-vector-health-report',
      element: <VectorHealthReport />,
      navIconsAlt: <HomeIcon />,
    },

    {
      name: 'Vector Health Question Report',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'view-vector-question-health-report/:qid/:qnumber/:value',
      element: <VectorHealthQuestionReport />,
      navIconsAlt: <HomeIcon />,
    },
    {
      name: 'Import Data Tool',
      navIcons: <ImportData />,
      path: 'import-data',
      element: <ImportDataTool />,
      navIconsAlt: <ImportData />,
      num: 1,
    },
  ];
} else {
  appNav = [
    {
      name: 'Update Password',
      image: require('../assets/images/dashboard.png').default,
      path: 'update-password',
      element: <UpdatePassword />,
    },
    {
      name: 'Update Details',
      image: require('../assets/images/dashboard.png').default,
      path: 'update-details',
      element: <UpdateDetails />,
    },
  ];
}

export default appNav;
